import styled from "@emotion/styled";

export const List = styled.div<{
  gap?: string;
  horizontalAlign?: "center" | "left";
}>`
  display: grid;
  ${({ horizontalAlign = "center" }) =>
    horizontalAlign === "center" && "justify-items: center"};
  grid-template-columns: 100%;
  grid-auto-rows: min-content;
  ${(props) => `gap: ${props.gap || "16px"};`}
`;
